import React from 'react';
import { t } from '@lingui/macro';

import { StyleProps } from '$/components/ui';
import { QuizIcon } from '$/images/FontAwesomeIcons';

import { QuizInfo } from './QuizInfo';

const QuizSummaryCard = React.lazy(() => import('./QuizSummaryCard'));

export class QuizSummaryInfo extends QuizInfo {
  public icon(): React.FC<StyleProps> {
    return QuizIcon;
  }

  public title(): string {
    return t`Your results`;
  }

  public cardBodyComponent(): React.FC | React.LazyExoticComponent<React.FC<{}>> {
    return QuizSummaryCard;
  }

  public shouldShowResultState(_playbackPosition: number): boolean {
    return true;
  }
}
